var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hotel-alerts-wrapper" }, [
    _c(
      "div",
      { ref: "header", staticClass: "hotel-alerts-header" },
      [
        _c("header-close", { attrs: { back: _vm.back } }, [
          _vm._v(
            _vm._s(_vm.selectedHotel.alertPanelTitle) +
              " (" +
              _vm._s(_vm.filteredAlerts.length) +
              ")"
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "hotel-alerts-content",
        style: [{ height: _vm.scrollHeight + "px" }],
      },
      [
        _c("h1", { staticClass: "hotel-alerts-hotel" }, [
          _vm._v(_vm._s(_vm.selectedHotel.propertyName)),
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "hotel-alerts-list" },
          _vm._l(_vm.filteredAlerts, function (alert) {
            return _c(
              "li",
              { key: alert.id, staticClass: "hotel-alerts-list-item" },
              [
                _c("h2", { staticClass: "hotel-alerts-list-item-title" }, [
                  _vm._v(_vm._s(alert.title)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "hotel-alerts-list-item-publish-date" },
                  [_vm._v(_vm._s(_vm.dateFormatted(alert.publishDate)))]
                ),
                _vm._v(" "),
                alert.imageUrl
                  ? _c("div", { staticClass: "hotel-alerts-list-item-image" }, [
                      _c(
                        "picture",
                        {
                          directives: [
                            {
                              name: "lazyload",
                              rawName: "v-lazyload",
                              value: {
                                src: alert.imageUrl,
                                set: [
                                  {
                                    width: "800",
                                    height: "450",
                                    breakpoint: "xs",
                                  },
                                  {
                                    width: "800",
                                    height: "450",
                                    breakpoint: "md",
                                  },
                                ],
                                fit: "crop",
                                align: "center",
                              },
                              expression:
                                "{\n              src: alert.imageUrl,\n              set: [\n                { width: '800', height: '450', breakpoint: 'xs' },\n                { width: '800', height: '450', breakpoint: 'md' }\n              ],\n              fit: 'crop',\n              align: 'center'\n            }",
                            },
                          ],
                          staticClass: "image-wrapper",
                        },
                        [
                          _c("img", {
                            staticClass: "image",
                            attrs: {
                              src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                              alt: alert.imageAlt,
                            },
                          }),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", {
                  staticClass: "hotel-alerts-list-item-description",
                  domProps: { innerHTML: _vm._s(alert.description) },
                }),
                _vm._v(" "),
                alert.ctaUrl
                  ? _c(
                      "a",
                      {
                        staticClass: "hotel-alerts-list-item-cta",
                        attrs: { href: alert.ctaUrl, target: "_blank" },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "hotel-alerts-list-item-cta-text" },
                          [_vm._v(_vm._s(alert.ctaLabel))]
                        ),
                        _vm._v(" "),
                        _c("em", { staticClass: "icon-chevron-right" }),
                      ]
                    )
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }